module.exports = __webpack_public_path__ + "img/news1.2c319b87.jpg";